const selector       = "[data-tabs-list]";
const tabActiveClass = "tab--active";

let els = null;

const TabsList = () => {

	// Search for carousel elements on page
	els = document.querySelectorAll(selector);

	// If there are any, continue
	if (els.length) {
		init();
	}
}

const init = () => {

	// Loop through them
	[].forEach.call(els, function(item) {

		// Add event listener for custom event dispatched by tab link
		item.addEventListener("tab-clicked", function(e) {
			
			// Get id of clicked tab
			const tabId = e.detail.tabId;
	
			// Loop through all tab links in this list
			[].forEach.call(item.querySelectorAll('[data-tab]'), function(tabLink) {
	
				// If tab link should be active
				const shouldBeActive = (tabLink.dataset.tab == tabId)
	
				// Change attributes accordingly
				tabLink.setAttribute("aria-selected", ((shouldBeActive) ? "true" : "false"));
				tabLink.setAttribute("tabindex", ((shouldBeActive) ? "0" : "-1"));
	
				// Also add/remove active class accordingly
				if (shouldBeActive) {
					tabLink.classList.add(tabActiveClass);
				} else {
					tabLink.classList.remove(tabActiveClass);
				}
			});
		})
	});
}

export default TabsList;